import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import HttpApi from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import App from './App';
import './App.css'

import {registerLicense } from '@syncfusion/ej2-base';
import I18NextHttpBackend from 'i18next-http-backend';
import Highcharts from 'highcharts';
// Registering Syncfusion license key
registerLicense('ORg4AjUWIQA/Gnt2VVhiQlFadVlJXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxRdkJhWH9XcnNQQ2dZVUY=');


require('highcharts/modules/exporting')(Highcharts);
require("highcharts/modules/export-data")(Highcharts);

i18next
  .use(I18NextHttpBackend) 
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ['ar', 'fr'],
    fallbackLng: 'ar', 
    debug: false,
    // Options for language detector
    detection: {
      order: ['path', 'cookie', 'htmlTag'],
      caches: ['cookie'],
    },
    react: { useSuspense: true },
    backend: {
      loadPath: '/assets/locales/{{lng}}/translation.json',
    },
  })

  

const loadingMarkup = (
  <div className="py-4 text-center">
     <div
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        fontSize: "2.5rem",
        transform: "translate(-50%, -50%)"
      }}
    >
      Chargement en cours ...
    </div>
    
  </div>
)





const root = ReactDOM.createRoot(document.getElementById('root'));  
root.render(
  
  <React.StrictMode>
    <Suspense fallback={loadingMarkup}>
    <App />
    </Suspense>
  </React.StrictMode>

);


